export default {
  isAuthenticated: state => !!state.token,
  authState: state => state.status,
  user: state => state.user,
  role_modules: state => state.role_modules,
  serverUrl: () => process.env.VUE_APP_SERVER_URL
}